import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/detail/${article.relatedMovieId}`}
      className="group flex flex-col sm:flex-row gap-3 md:gap-4 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4 transition-all duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative w-full sm:w-[180px] h-[120px] sm:h-[110px] shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
          {article.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 min-w-0">
        <h3 className="text-sm md:text-base font-medium leading-snug text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 line-clamp-2">
          {article.excerpt}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-400">
          <span className="whitespace-nowrap">
            <i className="ri-user-line mr-1" />
            {article.author}
          </span>
          <span className="whitespace-nowrap">
            <i className="ri-calendar-line mr-1" />
            {article.publishDate}
          </span>
          <span className="whitespace-nowrap">
            <i className="ri-time-line mr-1" />
            {article.readMinutes} 分钟阅读
          </span>
        </div>
      </div>
    </Link>
  );
}